module.exports = __webpack_public_path__ + "img/LR-LIFETAKT_loesungen-fuer-jede-lebenslage_kachel-5in1mensho.b48e3345.png";